import React from 'react';

function StellungnahmeDetailDialog({ stellungnahme, user, onClose, onNavigateToCustomer }) {
  
  const formatDate = (dateString) => {
    if (!dateString) return 'Nicht verfügbar';
    return new Date(dateString).toLocaleString('de-DE', {
      dateStyle: 'medium',
      timeStyle: 'short'
    });
  };

  const getStatusColor = (status) => {
    if (!status) return "";
    
    status = status.toLowerCase();
    if (status.includes('offen') || status.includes('neu')) return "status-new";
    if (status.includes('bearbeitung') || status.includes('in arbeit')) return "status-in-progress";
    if (status.includes('abgeschlossen') || status.includes('erledigt')) return "status-completed";
    if (status.includes('abgelehnt') || status.includes('storniert')) return "status-cancelled";
    return "";
  };

  // Funktion um Bearbeiter-Status zu ermitteln
  const getBearbeiterInfo = () => {
    if (stellungnahme.antwort && stellungnahme.antwort.trim() !== '') {
      // Es gibt eine Antwort, zeige "Bearbeitet von [Name]"
      const bearbeiterName = stellungnahme.antwort_user_name || 
                           stellungnahme.antwort_user_email || 
                           'Unbekannt';
      return `Bearbeitet von ${bearbeiterName}`;
    } else {
      // Keine Antwort vorhanden
      return 'Noch keine Antwort';
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-dialog" style={{ maxWidth: '700px' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <h3 style={{ margin: 0 }}>Stellungnahme</h3>
        </div>

        {/* Kunde Information */}
        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '20px', 
          borderRadius: '8px', 
          marginBottom: '20px',
          border: '1px solid #e9ecef'
        }}>
          <h4 style={{ 
            margin: '0 0 15px 0', 
            fontSize: '16px', 
            color: '#495057',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            Kunde Information
          </h4>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div>
              <strong>Name:</strong>
              <div style={{ marginTop: '4px', fontSize: '14px' }}>
                {stellungnahme.kunde_name || 'Nicht verfügbar'}
              </div>
            </div>
            <div>
              <strong>E-Mail:</strong>
              <div style={{ marginTop: '4px', fontSize: '14px' }}>
                {stellungnahme.kunde_email || 'Nicht verfügbar'}
              </div>
            </div>
            <div>
              <strong>Telefon:</strong>
              <div style={{ marginTop: '4px', fontSize: '14px' }}>
                {stellungnahme.kunde_handy || 'Nicht verfügbar'}
              </div>
            </div>
            <div>
              <strong>Status:</strong>
              <div style={{ position: 'relative' }}>
                  <div 
                  className={`status-badge ${getStatusColor(stellungnahme.status)}`} 
                  style={{ 
                      position: 'absolute',
                      top: '4px',
                      left: '0'
                  }}
                  >
                  {stellungnahme.status || 'Unbekannt'}
                  </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stellungnahme Details */}
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px', 
          marginBottom: '20px',
          border: '1px solid #e9ecef'
        }}>
          <h4 style={{ margin: '0 0 15px 0', fontSize: '16px', color: '#495057' }}>
            Ihre Stellungnahme
          </h4>
          
          <div style={{ marginBottom: '15px' }}>
            <strong>Erstellt am:</strong>
            <div style={{ marginTop: '4px', fontSize: '14px', color: '#6c757d' }}>
              {formatDate(stellungnahme.erstellt)}
            </div>
          </div>

          {/* Nachricht */}
          <div style={{ marginBottom: '15px' }}>
            <strong>Nachricht:</strong>
            <div style={{ 
              marginTop: '8px', 
              padding: '12px', 
              backgroundColor: '#f8f9fa', 
              borderRadius: '6px',
              fontSize: '14px',
              lineHeight: '1.6',
              whiteSpace: 'pre-wrap'
            }}>
              {stellungnahme.nachricht || 'Keine Nachricht verfügbar'}
            </div>
          </div>

          {/* Anhang */}
          {stellungnahme.anhang && (
            <div style={{ marginBottom: '15px' }}>
              <strong>Anhang:</strong>
              <div style={{ 
                marginTop: '8px', 
                padding: '8px 12px', 
                backgroundColor: '#e7f3ff', 
                borderRadius: '6px',
                fontSize: '14px',
                border: '1px solid #b3d9ff'
              }}>
                📎 {stellungnahme.anhang}
              </div>
            </div>
          )}
        </div>

        {/* Antwort Section */}
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px', 
          marginBottom: '20px',
          border: '1px solid #e9ecef'
        }}>
          <h4 style={{ margin: '0 0 15px 0', fontSize: '16px', color: '#495057' }}>
            Antwort vom Team
          </h4>
          
          {stellungnahme.antwort ? (
            <>
              {stellungnahme.antwort_erstellt && (
                <div style={{ marginBottom: '10px' }}>
                  <strong>Beantwortet am:</strong>
                  <div style={{ marginTop: '4px', fontSize: '14px', color: '#6c757d' }}>
                    {formatDate(stellungnahme.antwort_erstellt)}
                  </div>
                </div>
              )}
              <div style={{ 
                marginTop: '8px', 
                padding: '12px', 
                backgroundColor: '#f0f8f0', 
                borderRadius: '6px',
                fontSize: '14px',
                lineHeight: '1.6',
                whiteSpace: 'pre-wrap',
                border: '1px solid #d4edda'
              }}>
                {stellungnahme.antwort}
              </div>
            </>
          ) : (
            <div style={{ 
              padding: '12px', 
              backgroundColor: '#fff3cd', 
              borderRadius: '6px',
              fontSize: '14px',
              color: '#856404',
              border: '1px solid #ffeaa7',
              fontStyle: 'italic'
            }}>
              Noch keine Antwort erhalten. Dein Team wird sich zeitnah bei Dir melden.
            </div>
          )}
        </div>

        {/* Ersteller/Bearbeiter Information */}
        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '15px', 
          borderRadius: '6px', 
          marginBottom: '20px',
          border: '1px solid #e9ecef'
        }}>
          <div style={{ fontSize: '12px', color: '#6c757d' }}>
            {stellungnahme.antwort && stellungnahme.antwort.trim() !== '' ? (
              <>
                <strong>Bearbeitet von:</strong> {
                  stellungnahme.antwort_user_name || 
                  stellungnahme.antwort_user_email || 
                  'Unbekannt'
                }
              </>
            ) : (
              <>
                <strong>Noch keine Antwort</strong>
              </>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end',
          gap: '10px'
        }}>
          <button 
            onClick={onClose}
            style={{
              padding: '10px 20px',
              border: '1px solid #6c757d',
              borderRadius: '6px',
              backgroundColor: 'white',
              color: '#6c757d',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Schließen
          </button>
        </div>

      </div>
    </div>
  );
}

export default StellungnahmeDetailDialog;